import React, { useContext } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";
import brandlogo from "../../assets/img/illustrations/new-sikka-logo.png";
import logodark from "../../assets/img/illustrations/new-sikka-logo-dark.png";
import AppContext from "../../context/Context";

const Logo = ({ at, width, externalURL, height, className,src="", ...rest }) => {
  const { loginUserDetails, isDark } = useContext(AppContext);
  let isLoggedIn = JSON.parse(localStorage.getItem("isLoggedIn"));
  const logo = src ? src : brandlogo ;
  const isApiPlusExist =
    loginUserDetails?.is_partner == "1" &&
    loginUserDetails.user_type?.toLowerCase() !== "User".toLowerCase()
      ? sessionStorage.getItem("api_plus_plus")
        ? JSON.parse(sessionStorage.getItem("api_plus_plus"))
        : false
      : false;

  const getUrl = () => {
    const { PUBLIC_URL } = process.env;

    if (window.location.href.includes("authentication/api-plus-payment") && isApiPlusExist) {
      return `${PUBLIC_URL}/authentication/api-plus-payment`;
    }

    return loginUserDetails.is_partner === "0"
      ? `${PUBLIC_URL}/admin/dashboard`
      : `${PUBLIC_URL}/user/applications`;
  };
  
  const redirectURL = getUrl();

  return (
    <>
      {isLoggedIn ? (
        <>
          {!window.location.href.includes("Chatbox") ? (
            <Link
              to={redirectURL}
              className={classNames(
                "text-decoration-none",
                { "navbar-brand text-left": at === "navbar-vertical" },
                { "navbar-brand text-left": at === "navbar-top" }
              )}
              {...rest}
            >
              <div
                className={classNames(
                  "d-flex",
                  {
                    "align-items-center py-3": at === "navbar-vertical",
                    "align-items-center": at === "navbar-top",
                    "flex-center font-weight-extra-bold fs-5 mb-4":
                      at === "auth",
                  },
                  className
                )}
              >
                <img
                  className="mr-2"
                  src={isDark ? logodark : logo}
                  alt="Logo"
                  width={width}
                  height={height}
                />
              </div>
            </Link>
          ) : (
            <img
              className="mr-2"
              src={isDark ? logodark : logo}
              alt="Logo"
              width={width}
              height={height}
            />
          )}
        </>
      ) : externalURL ? (
        <a
          href={externalURL}
          target="_blank"
          className={classNames(
            "text-decoration-none",
            { "navbar-brand text-left": at === "navbar-vertical" },
            { "navbar-brand text-left": at === "navbar-top" }
          )}
        >
          <div
            className={classNames(
              "d-flex",
              {
                "align-items-center py-3": at === "navbar-vertical",
                "align-items-center": at === "navbar-top",
                "flex-center font-weight-extra-bold fs-5 mb-4": at === "auth",
              },
              className
            )}
          >
            <img
              className="mr-2"
              src={isDark ? logodark : logo}
              alt="Logo"
              width={width}
              height={height}
            />
          </div>
        </a>
      ) : (
        <Link
          to={process.env.PUBLIC_URL}
          className={classNames(
            "text-decoration-none",
            { "navbar-brand text-left": at === "navbar-vertical" },
            { "navbar-brand text-left": at === "navbar-top" }
          )}
          {...rest}
        >
          <div
            className={classNames(
              "d-flex",
              {
                "align-items-center py-3": at === "navbar-vertical",
                "align-items-center": at === "navbar-top",
                "flex-center font-weight-extra-bold fs-5 mb-4": at === "auth",
              },
              className
            )}
          >
            <img
              className="mr-2"
              src={isDark ? logodark : logo}
              alt="Logo"
              width={width}
              height={height}
            />
          </div>
        </Link>
      )}
    </>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(["navbar-vertical", "navbar-top", "auth"]),
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
};

Logo.defaultProps = { at: "auth", width: 250 };

export default Logo;
